import "./styles.less";

import { Col, Row, Skeleton, Space } from "antd";
import { ImageProps, usePropertyCover } from "./hook";
import React, { FC, useContext } from "react";

import { ConfigStateContext } from "../../../Contexts/Configurations/context";
import { Favorite } from "../../../Components/Property/Favorite/web";
import { ImagenOptimizada } from "../../../Components/Image/web";
import { ListingTypeTag } from "../../../Components/Property/ListingTypeTag/web";
import { PropertyCoverTags } from "./PropertyCoverTag/web";
import { ReportButton } from "../../../Components/Property/ReportButton/web";
import { SocialShare } from "../../../Components/Property/SocialShare/web";
import { TourIframe } from "../PropertyModal/PropertyModalTour3d/web";
import { useTheme } from "../../../Styles/ThemeHook";

const ImageHeader: FC<{ data: any; loading: boolean; tourUrl: string }> = ({
	data,
	loading,
	tourUrl,
}) => {
	if (loading) {
		return <Skeleton.Image />;
	}

	return tourUrl ? (
		<TourIframe url={tourUrl} />
	) : (
		<ImagenOptimizada src={data.img} alt="Image" minWith={742} minHeight={400} />
	);
};

export const PropertyCover: FC<ImageProps> = ({
	id,
	mode = "auto",
	onTabClick,
	loading = false,
	images,
	img,
	isProject,
	tour3d,
	files,
	youtube,
	latitude,
	isEspecial,
	isDisabledProperty = false,
}) => {
	const { data } = usePropertyCover(mode, images, isProject, img);
	const { theme } = useTheme();
	const { country_code } = useContext(ConfigStateContext);

	if (!data) return null;

	const fullWidth = data?.images?.length <= 2;
	const gridWidth = data?.images?.length >= 5;
	const tabToSelect = tour3d ? "tour3d" : "photos";

	const GRID_NORMAL_IMAGES_3 = (
		<>
			<Col span={24} lg={fullWidth ? 24 : 18}>
				<ImageHeader data={data} tourUrl={tour3d} loading={loading} />
			</Col>
			{!fullWidth && (
				<Col span={0} lg={6} className="left">
					<Row gutter={[0, theme.spacing.smSpacing]}>
						<Col span={24}>
							{loading ? (
								<Skeleton.Image />
							) : (
								<ImagenOptimizada src={data.images[1].image} alt="Image" minHeight={210} />
							)}
						</Col>
						<Col span={24}>
							{loading ? (
								<Skeleton.Image />
							) : (
								<ImagenOptimizada src={data.images[2].image} alt="Image" minHeight={210}/>
							)}
						</Col>
					</Row>
				</Col>
			)}
		</>
	);

	const GRID_ESPECIAL_IMAGES_3 = (
		<>
			<Col span={24} lg={fullWidth ? 24 : 16}>
				<div className="item-image">
					<div className="hover-zoom-in">
						<ImageHeader data={data} tourUrl={tour3d} loading={loading} />
					</div>
				</div>
			</Col>
			{!fullWidth && (
				<Col span={0} lg={8} className="left">
					<Row gutter={[theme.spacing.smSpacing, theme.spacing.smSpacing]}>
						<Col span={24}>
							{loading ? (
								<Skeleton.Image />
							) : (
								<div className="item-image">
									<div className="hover-zoom-in">
										<ImagenOptimizada src={data.images[1].image} alt="Image" minHeight={210}/>
									</div>
								</div>
							)}
						</Col>
						<Col span={24}>
							{loading ? (
								<Skeleton.Image />
							) : (
								<>
									<div className="item-image">
										<div className="hover-zoom-in">
											<ImagenOptimizada
												src={data.images[2].image}
												alt="Image"
												minHeight={210}
											/>
											<a href="#" className="img-overlay">
												<p className="max-property">{`+${data.images.length}`}</p>
												<p className="view-more">Ver más</p>
											</a>
										</div>
									</div>
								</>
							)}
						</Col>
					</Row>
				</Col>
			)}
		</>
	);

	const GRID_IMAGES_5 = (
		<>
			<Col span={24} md={12}>
				<div className="item-image">
					<div className="hover-zoom-in">
						<ImageHeader data={data} tourUrl={tour3d} loading={loading} />
					</div>
				</div>
			</Col>
			<Col span={0} md={12} className="left">
				<Row gutter={[theme.spacing.smSpacing, theme.spacing.smSpacing]}>
					<Col span={12}>
						{loading ? (
							<Skeleton.Image />
						) : (
							<div className="item-image">
								<div className="hover-zoom-in">
									<ImagenOptimizada src={data?.images[1]?.image} alt="Image" minHeight={210}/>
								</div>
							</div>
						)}
					</Col>
					<Col span={12}>
						{loading ? (
							<Skeleton.Image />
						) : (
							<div className="item-image">
								<div className="hover-zoom-in">
									<ImagenOptimizada src={data?.images[2]?.image} alt="Image" minHeight={210}/>
								</div>
							</div>
						)}
					</Col>
					<Col span={12}>
						{loading ? (
							<Skeleton.Image />
						) : (
							<div className="item-image">
								<div className="hover-zoom-in">
									<ImagenOptimizada src={data?.images[3]?.image} alt="Image" minHeight={210}/>
								</div>
							</div>
						)}
					</Col>
					<Col span={12}>
						{loading ? (
							<Skeleton.Image />
						) : (
							<>
								<div className="item-image">
									<div className="hover-zoom-in">
										<ImagenOptimizada
											src={data?.images[4]?.image}
											alt="Image"
											minHeight={210}
										/>
										<a href="#" className="img-overlay">
											<p className="max-property">{`+${data.images.length}`}</p>
											<p className="view-more">Ver más</p>
										</a>
									</div>
								</div>
							</>
						)}
					</Col>
				</Row>
			</Col>
		</>
	);

	const COVER_GRADIENT = (
		<div
			className="cover-gradient"
			onClick={loading ? null : () => { onTabClick(tabToSelect) }}></div>
	);

	return (
			<div
				className={`property_details_cover ${
					isEspecial
						? `property-details-cover-especial ${fullWidth ? "fullWidth" : ""}`
						: ""
				}`}>
				{isEspecial ? fullWidth && COVER_GRADIENT : COVER_GRADIENT}
				<Row className={"top-tags-buttons"}>
					{!isEspecial && (
						<Col flex={1}>
							<ListingTypeTag id={id} />
						</Col>
					)}
					<Col>
						<Space size="middle">
							<Favorite
								id={id}
								isDisabledProperty={isDisabledProperty}
								isEspecial={isEspecial}
							/>
							<SocialShare
								id={id}
								mode={mode}
								isEspecial={isEspecial}
								isDisabledProperty={isDisabledProperty}
							/>
							{country_code != "BR" && mode != "project" && (
								<ReportButton
									isDisabledProperty={isDisabledProperty}
									id={id}
									mode={mode}
									isEspecial={isEspecial}
								/>
							)}
						</Space>
					</Col>
				</Row>
				<Row className={"bottom-card-tags"}>
					<Col>
						<PropertyCoverTags
							onClick={tab => onTabClick(tab)}
							imageCount={isEspecial ? 0 : data.images.length || data.img&&1 || 0 }
							files={files}
							youtube={youtube}
							latitude={latitude}
							tour3d={tour3d}
							loading={loading}
						/>
					</Col>
				</Row>
				<Row
					gutter={theme.spacing.smSpacing}
					className={"property-cover-gallery"}
					onClick={loading ? null : () => onTabClick(tabToSelect)}>
					{!isEspecial
						? GRID_NORMAL_IMAGES_3
						: gridWidth
						? GRID_IMAGES_5
						: GRID_ESPECIAL_IMAGES_3}
				</Row>
			</div>
	);
};
